export const STRIPE_FORM_BASE_STYLES = {
  iconColor: '#666EE8',
  color: '#31325F',
  lineHeight: '40px',
  fontWeight: 300,
  fontFamily: '"Noto sans", Helvetica, sans-serif',
  fontSize: '14px',

  '::placeholder': {
    color: '#CFD7E0',
  },
};
